const state = {
   isUnauthenticated: false,
   isLoaderActive: null,
   isProductPromptPopupActive: false,
   loaderText: null,
}

export default state;